import { AxiosError } from 'axios'
import Image from 'next/image'
import { useState } from 'react'

import { InvoiceStatus } from '@/api/models/finance'
import { useInvoiceById } from '@/api/models/finance/hooks/useInvoiceById'
import { RequestTypeAlias } from '@/api/models/requests/lib/requests.types'
import { ServerValidationError } from '@/api/shared/types'
import { YandexMetrikaEvent } from '@/app/constants/metrics'
import { AppButton } from '@/components/shared/button'
import { ErrorModal } from '@/components/shared/modal/ui/ErrorModal'
import { useYandexMetrika } from '@/components/shared/yandex-metrika/hooks/useYandexMetrika'

type Props = {
  invoiceId: string | null
  requestType: RequestTypeAlias
  onPayClick: () => void
  onFormError: (error: AxiosError<ServerValidationError>) => void
}

const ContentBlockPayment = ({
  invoiceId,
  requestType,
  onPayClick,
  onFormError
}: Props) => {
  const { reachGoal } = useYandexMetrika()

  const { refetch } = useInvoiceById(invoiceId, false)
  const [isErrorModalShowing, setIsErrorModalShowing] = useState(false)

  const pay = async () => {
    reachGoal(
      requestType === RequestTypeAlias.CommonRequest
        ? YandexMetrikaEvent.PASSES_PAYMENT_BUTTON
        : YandexMetrikaEvent.NEW_REQUEST_PAYMENT_BUTTON
    )
    const result = await refetch()

    if (result.status === 'error') {
      onFormError(result.error as AxiosError<ServerValidationError>)
      return
    }

    if (result.status === 'success' && result.data) {
      const financeInvoice = result.data

      const shouldShowOpenModal =
        financeInvoice.isPaid ||
        (!financeInvoice.isPaid &&
          financeInvoice.status === InvoiceStatus.isProcessing)

      if (shouldShowOpenModal) {
        setIsErrorModalShowing(true)
      } else {
        onPayClick()
      }
    }
  }

  return (
    <>
      <AppButton className="gap-8 sm:mb-16" variant="secondary" onClick={pay}>
        <Image
          src="/images/requests/credit-card.svg"
          alt="arrow-right-btn"
          width={14}
          height={11}
        />
        <span>Оплатить</span>
      </AppButton>
      <ErrorModal
        headerText="Оплата обращения"
        text="Вы уже оплатили это обращение."
        opened={isErrorModalShowing}
        onClose={() => setIsErrorModalShowing(false)}
        bottomText="Статус обновится в ближайшее время."
        imageSrc="/images/balance/summary/ruble.png"
        imageClassName="rotate-0"
      />
    </>
  )
}

export { ContentBlockPayment }
